
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Form,
} from "reactstrap";


//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getSettings, updateSetting } from "../../store/settings/actions";

import FormEditors from "../Forms/FormEditors";


const AppFeatures = (props) => {
  const dispatch = useDispatch()
  const settings = useSelector(state => state.settings.settings)
  const [app_features_ar, setAppFeaturesAr] = useState("")
  const [app_features_en, setAppFeaturesEn] = useState("")
  const [app_features_fr, setAppFeaturesFr] = useState("")
  useEffect(() => {
    dispatch(getSettings())
  }, [dispatch])
  useEffect(() => {
    setAppFeaturesAr(settings.app_features_ar)
    setAppFeaturesEn(settings.app_features_en)
    setAppFeaturesFr(settings.app_features_fr)
  }, [settings])
  const handleSubmit = () => {
    dispatch(
      updateSetting({
        id: settings.id ?? 1,
        app_features_ar,
        app_features_en,
        app_features_fr,
      })
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="App features" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4>App Features</h4>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>
                    <Label>
                      <h4 className="card-title">English</h4>
                    </Label>

                    <FormEditors
                      value={app_features_en}
                      onChange={setAppFeaturesEn}
                    />
                    <Label>French</Label>
                    <FormEditors
                      value={app_features_fr}
                      onChange={setAppFeaturesFr}
                    />
                    <Label>
                      <h4 className="card-title">Arabic</h4>
                    </Label>
                    <FormEditors
                      value={app_features_ar}
                      onChange={setAppFeaturesAr}
                    />

                    <div className="d-flex flex-wrap gap-2">
                      <Button
                        type="button"
                        color="primary"
                        className=""
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>{" "}
                      <Button type="reset" color="secondary" className="">
                        Cancel
                      </Button>
                    </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default AppFeatures
